import React from "react";
import { FaCheckCircle, FaPlusCircle, FaTimesCircle } from "react-icons/fa";

type ValidationDeltaStatusIconProps = {
  delta: number | null | undefined;
  size?: number;
  matchTitle?: string;
  missingTitle?: string;
  extraTitle?: string;
};

export const ValidationDeltaStatusIcon: React.FC<ValidationDeltaStatusIconProps> = ({
  delta,
  size = 17,
  matchTitle = "Antall matcher",
  missingTitle = "Færre i modellen enn forventet",
  extraTitle = "Flere i modellen enn forventet",
}) => {
  if (delta === 0) {
    return <FaCheckCircle color="#2f9e44" size={size} title={matchTitle} />;
  }

  if (typeof delta === "number" && delta < 0) {
    return <FaTimesCircle color="#e03131" size={size} title={missingTitle} />;
  }

  if (typeof delta === "number" && delta > 0) {
    return <FaPlusCircle color="#1971c2" size={size} title={extraTitle} />;
  }

  return null;
};
